import {
  dossierAdvancedSearchItem,
  dossierSearchCriteria,
  userFilterWithSearchCriteriaDetailed
} from '@app/pcs/models';
import {gql} from 'apollo-angular';

export const userFilterWithSearchCriteriaDetailedQuery = gql`
  query UserFilterWithDetailedSearchCriteria {
    userFilter {
      ...userFilterWithSearchCriteriaDetailed
    }
  }
  ${userFilterWithSearchCriteriaDetailed}
`;

export const filterSearch = 'advancedSearch';
export const filterSearchQuery = gql`
    query AdvancedSearchQuery ($filterId: Long!) {
        advancedSearch (filterId: $filterId) {
            ...dossierAdvancedSearchItem
        }
    }
    ${dossierAdvancedSearchItem}
`;

export const searchCriteriaQuery = gql`
    query Filter($filterId: Long!) {
        filter (id: $filterId) {
            id
            dossierSearchModel {
                ...dossierSearchCriteria
            }
        }
    }
    ${dossierSearchCriteria}
`;

export const eligibleUsersForSharingResult = 'eligibleUsersForSharing';
export const eligibleUsersForSharingQuery = gql`
    query ShareEligibleUsers($filterId: Long!) {
        eligibleUsersForSharing (filterId: $filterId) {
            id
            name
            firstName
        }
    }
`;

export const sharedUsersResult = 'sharedUsers';
export const sharedUsersQuery = gql`
    query SharedUsers ($filterId: Long!) {
        sharedUsers (filterId: $filterId) {
            id
            name
            firstName
        }
    }
`;
